import { ITheme } from "survey-core";

export const claimableConsoleSurveyTheme: ITheme = {
  themeName: "claimable",
  colorPalette: "light",
  isPanelless: true,
  cssVariables: {
    "--sjs-primary-backcolor": "#8f8bad",
    "--sjs-primary-backcolor-light": "rgba(143, 139, 173, 0.1)",
    "--sjs-primary-backcolor-dark": "rgb(143, 139, 173)",
    "--sjs-primary-forecolor": "#FFFFFF",
    "--sjs-primary-forecolor-light": "rgba(255, 255, 255, 0.25)",
    "--sjs-base-unit": "4px",
    "--sjs-corner-radius": "4px",
    "--sjs-secondary-backcolor": "#f1f3f5",
    "--sjs-secondary-backcolor-light": "rgba(241, 243, 245, 0.5)",
    "--sjs-secondary-backcolor-semi-light": "rgba(241, 243, 245, 0.25)",
    "--sjs-secondary-forecolor": "#252423",
    "--sjs-secondary-forecolor-light": "rgba(37, 36, 35, 0.45)",
    "--sjs-shadow-small": "0px 2px 4px rgba(0, 0, 0, 0.1)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0)",
    "--sjs-shadow-medium": "0px 4px 8px rgba(0, 0, 0, 0.1)",
    "--sjs-shadow-large": "0px 8px 16px rgba(0, 0, 0, 0.1)",
    "--sjs-shadow-inner": "inset 0px 2px 2px rgba(0, 0, 0, 0.1)",
    "--sjs-shadow-inner-reset": "inset 0px 0px 0px 0px rgba(0, 0, 0, 0)",
    "--sjs-border-light": "rgb(225, 225, 224)",
    "--sjs-border-default": "#ced4da",
    "--sjs-border-inside": "#f1f3f5",
    "--sjs-special-red": "#a6561a",
    "--sjs-special-red-forecolor": "#FFFFFF",
    "--sjs-special-green": "#349b6f",
    "--sjs-special-green-forecolor": "#FFFFFF",
    "--sjs-special-yellow": "#ff6d00",
    "--sjs-special-yellow-forecolor": "#FFFFFF",
    "--sjs-special-blue": "#29a7d3",
    "--sjs-special-blue-forecolor": "#FFFFFF",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontFamily": "Krona One, sans-serif",
    "--sjs-article-font-xx-large-fontSize": "48px",
    "--sjs-article-font-xx-large-lineHeight": "48px",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-fontFamily": "Krona One, sans-serif",
    "--sjs-article-font-large-fontSize": "24px",
    "--sjs-article-font-large-lineHeight": "28px",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontWeight": "500",
    "--sjs-article-font-medium-fontFamily": "Manrope, sans-serif",
    "--sjs-article-font-medium-fontSize": "16px",
    "--sjs-article-font-medium-lineHeight": "24px",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontFamily": "Manrope, sans-serif",
    "--sjs-article-font-default-fontSize": "16px",
    "--sjs-article-font-default-lineHeight": "24px",
    "--sjs-general-backcolor": "#FFFFFF",
    "--sjs-general-backcolor-dark": "#f1f3f5",
    "--sjs-general-backcolor-dim": "#fffefb",
    "--sjs-general-backcolor-dim-light": "#FFFFFF",
    "--sjs-general-backcolor-dim-dark": "#f1f3f5",
    "--sjs-general-forecolor": "#252423",
    "--sjs-general-forecolor-light": "rgba(37, 36, 35, 0.45)",
    "--sjs-general-dim-forecolor": "#666665",
    "--sjs-general-dim-forecolor-light": "rgba(102, 102, 101, 0.45)",
    "--sjs-font-family": "Manrope, sans-serif",
    "--sjs-font-size": "14px",
    "--sjs-question-background": "#FFFFFF",
    "--font-scale-factor": "1",
    "--sjs-header-backcolor": "#fffefb",
    "--sjs-header-forecolor": "#252423",
    "--sjs-progress-backcolor": "rgb(225, 225, 224)",
    "--sjs-progress-forecolor": "#8f8bad",
    "--sjs-error-backcolor": "rgb(255, 231, 214)",
    "--sjs-error-forecolor": "#ff3439",
    "--sjs-error-border-color": "#ff3439",
    "--sjs-error-background-light": "rgba(255, 231, 214, 0.3)",
    "--sjs-question-error-spacing": "8px",
    "--sjs-success-backcolor": "rgb(222, 239, 232)",
    "--sjs-success-forecolor": "#349b6f",
    "--sjs-spacing-xs": "3px",
    "--sjs-spacing-sm": "4px",
    "--sjs-spacing-md": "6px",
    "--sjs-spacing-lg": "10px",
    "--sjs-spacing-xl": "14px",
    "--sjs-spacing-2xl": "20px",
  },
};
